import { GetUnnamedHeatmapResponse, HeatmapDetail } from '@fullstory/proto/fs/services/dx-objects';
import { timestamp } from '@fullstory/proto/google/protobuf';
import { HeatmapSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { Event } from '@fullstory/proto/fs/api/segment';
import { RepresentativePage } from '@fullstory/proto/fs/services/search-settings';
import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';

export type HeatmapsById = { [id: string]: HeatmapDetail };
export type HeatmapsState = HeatmapsById;
export type UnnamedHeatmapState = GetUnnamedHeatmapResponse;

export enum HeatmapsRequestTypes {
  ArchiveHeatmapFailure = 'Heatmaps.Archive.Failure',
  ArchiveHeatmapRequest = 'Heatmaps.Archive.Request',
  ArchiveHeatmapSuccess = 'Heatmaps.Archive.Success',
  ComputeHeatmapFailure = 'Heatmaps.Compute.Failure',
  ComputeHeatmapRequest = 'Heatmaps.Compute.Request',
  ComputeHeatmapSuccess = 'Heatmaps.Compute.Success',
  ComputeHeatmapZoneFailure = 'Heatmaps.Compute.Zones.Failure',
  ComputeHeatmapZoneRequest = 'Heatmaps.Compute.Zones.Request',
  ComputeHeatmapZoneSuccess = 'Heatmaps.Compute.Zones.Success',
  CreateUnnamedHeatmapFailure = 'Heatmaps.CreateUnnamed.Failure',
  CreateUnnamedHeatmapRequest = 'Heatmaps.CreateUnnamed.Request',
  CreateUnnamedHeatmapSuccess = 'Heatmaps.CreateUnnamed.Success',
  GetAllHeatmapsFailure = 'Heatmaps.GetAll.Failure',
  GetAllHeatmapsRequest = 'Heatmaps.GetAll.Request',
  GetAllHeatmapsSuccess = 'Heatmaps.GetAll.Success',
  GetHeatmapAccessFailure = 'Heatmaps.GetAccess.Failure',
  GetHeatmapAccessRequest = 'Heatmaps.GetAccess.Request',
  GetHeatmapAccessSuccess = 'Heatmaps.GetAccess.Success',
  GetUnnamedHeatmapFailure = 'Heatmaps.GetUnnamed.Failure',
  GetUnnamedHeatmapRequest = 'Heatmaps.GetUnnamed.Request',
  GetUnnamedHeatmapSuccess = 'Heatmaps.GetUnnamed.Success',
  HeatmapsAppCacheClear = 'Heatmaps.APP_CACHE_CLEAR',
  HeatmapsAppCacheFresh = 'Heatmaps.APP_CACHE_FRESH',
  HeatmapsAppCacheHasData = 'Heatmaps.APP_CACHE_HAS_DATA',
  HeatmapsAppCacheIsLoading = 'Heatmaps.APP_CACHE_IS_LOADING',
  HeatmapsAppCacheLoadFailed = 'Heatmaps.APP_CACHE_LOAD_FAILED',
  HeatmapsAppCacheRefetching = 'Heatmaps.APP_CACHE_IS_REFETCHING',
  HeatmapsAppCacheSwap = 'Heatmaps.APP_CACHE_SWAP',
  HeatmapsClickAreaAppCacheClear = 'Heatmaps.ClickArea.APP_CACHE_CLEAR',
  HeatmapsClickAreaAppCacheFresh = 'Heatmaps.ClickArea.APP_CACHE_FRESH',
  HeatmapsClickAreaAppCacheHasData = 'Heatmaps.ClickArea.APP_CACHE_HAS_DATA',
  HeatmapsClickAreaAppCacheIsLoading = 'Heatmaps.ClickArea.APP_CACHE_IS_LOADING',
  HeatmapsClickAreaAppCacheLoadFailed = 'Heatmaps.ClickArea.APP_CACHE_LOAD_FAILED',
  HeatmapsClickAreaAppCacheRefetching = 'Heatmaps.ClickArea.APP_CACHE_IS_REFETCHING',
  HeatmapsClickAreaAppCacheSwap = 'Heatmaps.ClickArea.APP_CACHE_SWAP',
  MarkViewedFailure = 'Heatmaps.MarkViewed.Failure',
  MarkViewedRequest = 'Heatmaps.MarkViewed.Request',
  MarkViewedSuccess = 'Heatmaps.MarkViewed.Success',
  SetHeatmapsFailure = 'Heatmaps.Set.Failure',
  SetHeatmapsRequest = 'Heatmaps.Set.Request',
  SetHeatmapsSuccess = 'Heatmaps.Set.Success',
  StarHeatmapFailure = 'Heatmaps.Star.Failure',
  StarHeatmapRequest = 'Heatmaps.Star.Request',
  StarHeatmapSuccess = 'Heatmaps.Star.Success',
}

export interface FlatHeatmap {
  id: string;
  name: string;
  description: string;
  heatmapEvent: Event;
  representativePage: RepresentativePage | null;
  heatmapSettings: HeatmapSettings;
  archived: boolean;
  starred: boolean;
  created: timestamp | null;
  createdBy: string;
  lastUpdated: timestamp | null;
  lastUpdatedBy: string;
  lastViewed: timestamp | null;
  visibility: Visibility;
}

export type HeatmapFormType = Pick<
  FlatHeatmap,
  | 'id'
  | 'name'
  | 'description'
  | 'archived'
  | 'heatmapEvent'
  | 'heatmapSettings'
  | 'representativePage'
  | 'visibility'
>;
